import { removeEmptyTemplate } from 'utils/tinyMCE/updateDynamicText/removeEmptyTemplate'
import { findParentWithAttribute } from '../caseDetails/findParentWithAttribute'

export const highlightDynamicTextPlugin = (editorProps) => {
  const { editor } = editorProps
  const isHighlighted = new WeakMap()

  const toggleHighlight = (element) => {
    const range = editor.dom.createRng()
    range.selectNodeContents(element)
    const selection = editor.selection

    selection.setRng(range)
    isHighlighted.set(element, true)
  }

  editor.on('click', (e) => {
    const target = e.target
    const parentWithAttribute = findParentWithAttribute(target)

    if (parentWithAttribute) {
      e.preventDefault()
      toggleHighlight(parentWithAttribute)
    }
  })

  editor.on('keypress', () => {
    const selection = editor.selection
    const elementWithAttribute = findParentWithAttribute(selection.getNode())

    const isReplacingHighlightedElement =
      elementWithAttribute && isHighlighted.has(elementWithAttribute)
    if (isReplacingHighlightedElement) {
      editor.dom.remove(elementWithAttribute)
      isHighlighted.delete(elementWithAttribute)
    }
  })

  editor.on('keydown', (e) => {
    const isDeleting = e.keyCode === 8 || e.keyCode === 46
    if (isDeleting) {
      const selection = editor.selection
      const elementWithAttribute = findParentWithAttribute(selection.getNode())
      const isDeletingHighlightedElementWithAttribute =
        elementWithAttribute && isHighlighted.has(elementWithAttribute)
      if (isDeletingHighlightedElementWithAttribute) {
        removeEmptyTemplate(editor, true)
      }
    }
  })
}

export default highlightDynamicTextPlugin
